function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import BrowserPersistence from '../../util/simplePersistence';
import userActions, { signOut } from '../actions/user';
var timeouts = new Map();
var intervals = new Map();
var storage = new BrowserPersistence();
var SET_TOKEN = userActions.setToken.toString();
var CLEAR_TOKEN = userActions.clearToken.toString();
var GET_DETAILS = userActions.getDetails.request.toString();

var isSigningIn = function isSigningIn(type) {
  return type === SET_TOKEN || type === GET_DETAILS;
};

var isSigningOut = function isSigningOut(type) {
  return type === CLEAR_TOKEN;
};
/**
 * This function adheres to Redux's middleware pattern.
 *
 * @param {Store} store The store to augment.
 * @returns {Function}
 */


var scheduleSignOut = function scheduleSignOut(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;

      if (isSigningIn(action.type)) {
        // `BrowserPersistence.getItem()` only returns the value
        // but we need the full item with timestamp and ttl
        var item = storage.getRawItem('signin_token'); // exit if there's nothing in storage

        if (!item) return next(action);

        var _JSON$parse = JSON.parse(item),
            timeStored = _JSON$parse.timeStored,
            ttl = _JSON$parse.ttl,
            value = _JSON$parse.value;

        var parsedValue = JSON.parse(value);
        var preciseTTL = ttl * 1000;
        var elapsed = Date.now() - timeStored;
        var expiry = Math.max(preciseTTL - elapsed, 0); // establish a sign-out routine

        var callback = function callback() {
          dispatch(signOut()).then(function () {
            timeouts.delete(parsedValue);
            intervals.delete(parsedValue); // refresh the page, important for checkout

            history.go(0);
          });
        }; // set a timeout that runs once when the token expires


        if (!timeouts.has(parsedValue)) {
          var timeoutId = setTimeout(callback, expiry);
          timeouts.set(parsedValue, timeoutId);
        } // then set an interval that runs once per second
        // on mobile, the timeout won't fire if the tab is inactive


        if (!intervals.has(parsedValue)) {
          var intervalId = setInterval(function () {
            var hasExpired = Date.now() - timeStored > preciseTTL;
            if (hasExpired) callback();
          }, 1000);
          intervals.set(parsedValue, intervalId);
        }
      } else if (isSigningOut(action.type)) {
        var _iterator = _createForOfIteratorHelper(timeouts),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _timeoutId = _step.value;
            clearTimeout(_timeoutId);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(intervals),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _intervalId = _step2.value;
            clearInterval(_intervalId);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        timeouts.clear();
        intervals.clear();
      }

      return next(action);
    };
  };
};

export default scheduleSignOut;